export default __webpack_public_path__ + "static/media/gccWeatherMonitor.edceb524.jpg";